import AdminText from './AdminText';
import React, { useState } from 'react';
import { translateAdmin } from '../../utils/adminTranslations';
import axios from 'axios';
import { apiUrl } from '../../config';
import { formatDateTime } from '../../utils/dynamic';

const DownloadReportBookings = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sort, setSort] = useState('topay');

  const headers = [
    "Заметка",
    "Тип бронирования",
    "Тип комнаты",
    "Номер телефона",
    "Дата въезда",
    "Дата выезда",
    "Гости",
    "Создал",
  ];

  const handleFetchReport = async () => {
    if ((!startDate && endDate) || (startDate && !endDate)) {
      alert(translateAdmin("Пожалуйста, выберите обе даты!"));
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${apiUrl}/api/sys/generate-report-all/bookings`, {
        params: { type: 'day', start_date: startDate, end_date: endDate, sort: sort },
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;
      if (!data || !data.data || data.data.length === 0) {
        alert(translateAdmin("Нет бронирований за выбранный период."));
        return;
      }

      setReportData(data);
      setShowModal(true);
    } catch (err) {
      alert(err?.response?.data?.request?.message || translateAdmin("Произошла ошибка при получении отчета."));
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    if (!reportData) return;

    // Берем только таблицу из модалки
    const printContents = document.getElementById('report-table').outerHTML;

    // Создаем iframe для печати, чтобы не менять страницу
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
    <html>
      <head>
        <style>
        <style>
          @media print {
            @page { size: A4 portrait; margin: 5mm; }
            body { font-family: Arial, sans-serif; margin:0; padding:0; }
            table { width: 100% !important; border-collapse: collapse; border-spacing: 0; page-break-inside: auto; }
            th, td { border: 1px solid #585858; padding: 2px 2px; text-align: left; word-wrap: break-word; }
            th { background-color: #f0f0f0; }
            thead { display: table-header-group; }
            tr { page-break-inside: avoid; }
          }
          table { width: 100%; border-collapse: collapse; border-spacing: 0; margin: 0 auto; }
          th, td { border: 1px solid #585858; padding: 2px 2px; text-align: left; font-size: 10px; }
          th { background-color: #f0f0f0; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Убираем iframe после печати
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };


  return (
    <div>
      <div className='d-flex'>
        <div className='dinput-block'>
          <label><AdminText>Начальная дата:</AdminText></label>
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className='dinput' />
        </div>
        <div className='dinput-block'>
          <label><AdminText>Конечная дата:</AdminText></label>
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className='dinput' />
        </div>
      </div>
      <select className='dinput-block dinput' onChange={e => setSort(e.target.value)} >
        <option value="topay"><AdminText>Должны оплатить</AdminText></option>
        <option value="unpaid"><AdminText>Не оплаченые</AdminText></option>
        <option value="paid"><AdminText>Оплаченые</AdminText></option>
        <option value="all"><AdminText>Все</AdminText></option>
      </select>

      <button onClick={handleFetchReport} disabled={loading} className='system-booking-table-btn system-booking-table-btn-view'>
        {loading ? translateAdmin("Загрузка...") : translateAdmin("Получить отчет")}
      </button>

      {showModal && reportData && (
        <div className="modal-overlay booking-report-modal">
          <div className="modal-content">
            <div className="table-container" id="report-table">
              <h2>Отчет бронирований</h2>
              <table>
                <thead>
                  <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {reportData.data.map((row, i) => (
                    <tr key={i}>
                      <td>{row.note}</td>
                      <td>{row.payment_type}</td>
                      <td>{row.room_type}</td>
                      <td>{row.phone_number || ''}</td>
                      <td>{formatDateTime(row.checkin_date)}</td>
                      <td>{formatDateTime(row.checkout_date)}</td>
                      <td>
                        {row.guests.map((g, index) => (
                          <div key={index}>{index+1}: {g.full_name}</div>
                        ))}
                      </td>
                      <td>{row.created_by_user_name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-buttons">
              <button onClick={handlePrint} className='system-booking-table-btn system-booking-table-btn-view'><AdminText>Печать</AdminText></button>
              <button onClick={() => setShowModal(false)} className='system-booking-table-btn system-booking-table-btn-cancel'><AdminText>Закрыть</AdminText></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadReportBookings;
